import React, { useState } from 'react';
import i18next from 'core/i18n';
import { IconButton } from '@indigo-ag/component-module';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';

import {
  BackgroundCheckModalLabor,
  BackgroundCheckModalLaborProps
} from './components/BackgroundCheckModalLabor/BackgroundCheckModalLabor';
import { SingleRow } from '../../SingleRow';
import { ILaborInfo, evaluationTypesOptions, PhaseSection } from 'shared';

interface LaborProps extends Partial<Pick<BackgroundCheckModalLaborProps, 'onSave'>> {
  disabled?: boolean;
  laborInfo?: ILaborInfo;
}

export const Labor: React.FunctionComponent<LaborProps> = ({ laborInfo, onSave, disabled }) => {
  /**
   * State
   */
  const [modalOpen, setModalOpen] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
  };

  const openLaborModal = () => {
    setModalOpen(true);
  };

  const laborEvaluationTranslated = laborInfo?.laborEvaluation
    ? evaluationTypesOptions.find(e => e.value === laborInfo.laborEvaluation)?.name
    : '-';

  return (
    <>
      <PhaseSection
        title={i18next.t('labor')}
        topRightContent={onSave && <IconButton icon={faEdit} disabled={disabled} onClick={openLaborModal} />}
      >
        {laborInfo?.laborEvaluation ? (
          <SingleRow title={i18next.t('evaluation')} content={laborEvaluationTranslated} />
        ) : null}
      </PhaseSection>

      {onSave ? (
        <BackgroundCheckModalLabor closeModal={closeModal} open={modalOpen} laborInfo={laborInfo} onSave={onSave} />
      ) : null}
    </>
  );
};
